module.exports = __webpack_public_path__ + "img/image002.5ebb6a29.jpg";